<template>
  <v-dialog v-model="show" persistent max-width="480" @keydown.esc="onCancel">
    <v-card>
      <v-card-title class="primary white--text">
        {{ use_language.select_warehouse_label }} (Select Warehouse)
      </v-card-title>
      <v-card-text class="pt-4">
        <div v-if="loading" class="text-center pa-4">
          <v-progress-circular indeterminate color="primary" />
        </div>
        <template v-else>
          <div v-if="warehouses.length" class="d-flex align-center mb-2">
            <span class="caption grey--text">{{ use_language.select_warehouse_to_sell }}</span>
            <v-spacer />
            <span class="caption grey--text">{{ use_language.all_ }} {{ warehouses.length }} {{ use_language.treasury }}</span>
          </div>

          <v-list dense class="wh-list">
            <v-list-item-group v-model="selectedIndex" color="primary">
              <v-list-item
                v-for="(w, i) in warehouses"
                :key="w.id"
                :value="i"
                @dblclick="confirm"
              >
                <v-list-item-avatar size="30" :color="selectedIndex === i ? 'primary' : 'grey lighten-2'">
                  <span :class="selectedIndex === i ? 'white--text caption font-weight-bold' : 'caption font-weight-bold'">
                    {{ i + 1 }}
                  </span>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">{{ w.name }}</v-list-item-title>
                  <v-list-item-subtitle v-if="w.address">{{ w.address }}</v-list-item-subtitle>
                  <v-list-item-subtitle v-else class="grey--text text--lighten-1">
                    {{ use_language.address_not_specified }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action v-if="selectedIndex === i">
                  <v-icon color="primary">mdi-check-circle</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>

          <div v-if="!warehouses.length" class="grey--text text-center pa-8">
            <v-icon size="48" color="grey lighten-1">mdi-warehouse</v-icon>
            <div class="mt-2">{{ use_language.warehouse_not_found_label }}</div>
          </div>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="onCancel" v-if="cancellable">{{ use_language.cancel }}</v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          :disabled="selectedIndex == null || loading"
          @click="confirm"
        >
          {{ use_language.confirm }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { shopService_dotnet } from '@/website/global'
import { get_languages } from '@/website/global_function'

export default {
  name: 'PosWarehouseDialog',
  props: {
    value: { type: Boolean, default: false },
    cancellable: { type: Boolean, default: true }
  },
  data: () => ({
    header_token: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('authorization_token') },
    warehouses: [],
    selectedIndex: null,
    loading: false,
    use_language: {}
  }),
  computed: {
    show: {
      get () { return this.value },
      set (v) { this.$emit('input', v) }
    }
  },
  watch: {
    show: {
      immediate: true,
      handler (v) {
        if (v) this.load()
      }
    }
  },
  async created () {
    this.use_language = await this.get_languages(localStorage.getItem('set_language'))
  },
  methods: {
    get_languages,
    async load () {
      this.loading = true
      this.selectedIndex = null
      try {
        const shopId = localStorage.getItem('shop_id')
        const res = await axios.post(
          shopService_dotnet + 'Shop/get-warehouse-list',
          { shopID: shopId },
          { headers: this.header_token }
        )
        if (res.status === 200) {
          this.warehouses = res.data || []
        }
      } catch (err) {
        this.$swal({ position: 'top', type: 'error', text: err.message })
      }
      this.loading = false
    },
    confirm () {
      if (this.selectedIndex == null) return
      const w = this.warehouses[this.selectedIndex]
      this.$emit('select', { id: w.id, name: w.name })
      this.show = false
    },
    onCancel () {
      if (!this.cancellable) return
      this.$emit('cancel')
      this.show = false
    }
  }
}
</script>

<style scoped>
.wh-list {
  max-height: 340px;
  overflow-y: auto;
  border: 1px solid #eceff1;
  border-radius: 6px;
  padding: 0;
}
.wh-list >>> .v-list-item {
  border-bottom: 1px solid #f5f5f5;
}
.wh-list >>> .v-list-item:last-child {
  border-bottom: none;
}
</style>
